@import '~style-sheet-helpers/core.less';
@import '../../../../../../constants/spacing.module.less';

.add-carrier-button-row {
  margin-bottom: @space-16;
  justify-content: flex-end;
}

.upgrade-call-to-action {
  margin: @space-24;
}

.add-carrier-button {
  display: flex;
  gap: @space-8;
}

.feature-gate-icon {
  width: 12px;
}

@media @wide-desktop {
  .upgrade-call-to-action {
    width: 80%;
  }
}
